import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Snippet from "./install-js-snippet.mdx";
import InstallWebPackageManagers from "./install-web-package-managers.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 {...{
      "id": "option-1-add-the-javascript-snippet-to-your-html-span-classbg-accent-text-gray-font-semibold-align-middle-text-sm-p-1-roundedrecommendedspan"
    }}>{`Option 1: Add the JavaScript snippet to your HTML `}<span className="bg-accent text-gray font-semibold align-middle text-sm p-1 rounded">{`Recommended`}</span></h3>
    <Snippet mdxType="Snippet" />
    <h3 {...{
      "id": "option-2-install-via-package-manager"
    }}>{`Option 2: Install via package manager`}</h3>

    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <p>{`And then include it with your project API key and host (which you can find in `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project"
      }}>{`your project settings`}</a>{`):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`import posthog from 'posthog-js'

posthog.init('<ph_project_api_key>', {
  api_host: '<ph_client_api_host>',
  defaults: '<ph_posthog_js_defaults>'
})
`}</code></pre>
    <p>{`See our framework specific docs for `}<a parentName="p" {...{
        "href": "/docs/libraries/next-js"
      }}>{`Next.js`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/libraries/react"
      }}>{`React`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/libraries/vue-js"
      }}>{`Vue`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/libraries/angular"
      }}>{`Angular`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/libraries/astro"
      }}>{`Astro`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/libraries/remix"
      }}>{`Remix`}</a>{`, and `}<a parentName="p" {...{
        "href": "/docs/libraries/svelte"
      }}>{`Svelte`}</a>{` for more installation details.`}</p>
    <details>
      <summary>Bundle all required extensions (advanced)</summary>
      <p>{`By default, the JavaScript Web library only loads the core functionality. It lazy-loads extensions such as surveys or the session replay 'recorder' when needed. `}</p>
      <p>{`This can cause issues if:`}</p>
      <ul>
        <li parentName="ul">{`You have a Content Security Policy (CSP) that blocks inline scripts. `}</li>
        <li parentName="ul">{`You want to optimize your bundle at build time to ensure all dependencies are ready immediately.`}</li>
        <li parentName="ul">{`Your app is running in environments like the Chrome Extension store or `}<a parentName="li" {...{
            "href": "/tutorials/electron-analytics"
          }}>{`Electron`}</a>{` that reject or block remote code loading.`}</li>
      </ul>
      <p>{`To solve these issues, we have multiple import options available below.`}</p>
      <p><strong parentName="p">{`Note:`}</strong>{` With any of the `}<inlineCode parentName="p">{`no-external`}</inlineCode>{` options, the toolbar will be unavailable as this is only possible as a runtime dependency loaded directly from `}<inlineCode parentName="p">{`us.posthog.com`}</inlineCode>{`.`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`// No external code loading possible (this disables all extensions such as Replay, Surveys, Exceptions etc.)
import posthog from 'posthog-js/dist/module.no-external'

// No external code loading possible but all external dependencies pre-bundled
import posthog from 'posthog-js/dist/module.full.no-external'

// All external dependencies pre-bundled and with the ability to load external scripts (primarily useful is you use Site Apps)
import posthog from 'posthog-js/dist/module.full'

// Finally you can also import specific extra dependencies 
import "posthog-js/dist/recorder"
import "posthog-js/dist/surveys"
import "posthog-js/dist/exception-autocapture"
import "posthog-js/dist/tracing-headers"
import "posthog-js/dist/web-vitals"
import posthog from 'posthog-js/dist/module.no-external'

// All other posthog commands are the same as usual
posthog.init('<ph_project_api_key>', { api_host: '<ph_client_api_host>', defaults: '<ph_posthog_js_defaults>' })
`}</code></pre>
      <p><strong parentName="p">{`Note:`}</strong>{` You should ensure if using this option that you always import `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` from the same module, otherwise multiple bundles could get included. At this time `}<inlineCode parentName="p">{`@posthog/react`}</inlineCode>{` does not work with any module import other than the default.`}</p>
    </details>
    <details>
      <summary>Don't want to send test data while developing?</summary>
      <p>{`If you don't want to send test data while you're developing, you can do the following:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
    posthog.init('<ph_project_api_key>', { api_host: '<ph_client_api_host>', defaults: '<ph_posthog_js_defaults>' })
}
`}</code></pre>
    </details>
    <details>
      <summary>What is the `defaults` option?</summary>
      <p>{`The `}<inlineCode parentName="p">{`defaults`}</inlineCode>{` is a date, such as `}<inlineCode parentName="p">{`2025-11-30`}</inlineCode>{`, for a configuration snapshot used as defaults to initialize PostHog. This default is overridden when you explicitly set a value for any of the options.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      